import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dzynp8b3sq: FaireBrandEntity = {
  token: "b_dzynp8b3sq",
  type: "brand",
  name: "Guerrilla Charm",
  avatarUrl:
    "https://cdn.faire.com/fastly/d28daea7ee9e95e8628849afea56a369ae713d9f63c1ab8ae601e07cd202d797.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5b102bccd74ef0118ef6f034c4d32396b00a5f5f8470d47fe756ff4c53b491e4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d28daea7ee9e95e8628849afea56a369ae713d9f63c1ab8ae601e07cd202d797.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5b102bccd74ef0118ef6f034c4d32396b00a5f5f8470d47fe756ff4c53b491e4.jpeg",
  location: "Superior, CO, USA",
  minimumOrderDollars: 103,
  rating: 5,
  reviewCount: 26,
  isTopShop: true,
  isInsider: true,
  description:
    "Guerrilla Charm was created by two sisters with a love of crafting.  We are a small, women-owned family business specializing in unique and high quality charms, pendants, and jewelry findings.  We have charms from A to Z - and everything in between! ",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:09.038Z",
    importedBy: "entity-db-cli",
  },
};
